import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function inventoryHistoryModel() {
  const fetchInventoryHistoryGroupList = reactive({
    api: apiEndpoint.bcrm_platform + "/InventoryMaster/History",
    method: "POST",
    payload: {
      Privilege_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchInventoryHistoryList = reactive({
    api: apiEndpoint.bcrm_platform + "/Inventory/History",
    method: "POST",
    payload: {
      Privilege_Id: 0,
      Inventory_Id: 0,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  return {
    fetchInventoryHistoryGroupList,
    fetchInventoryHistoryList
  };
}
